module.exports = __webpack_public_path__ + "static/media/model_result_negative.68373078.gif";